import React from 'react';
import { Table, Icon } from 'antd';
import TablePageSize from '../../../../../../common/components/TablePageSize';

const placeholder = <Icon type="loading" style={{ fontSize: 44 }} spin />;

const OrdersTable = props => {
  const {
    orders,
    pages,
    onChangeTable,
    changePaginationSize,
    renderColumns,
    tableColumnsLen,
    ordersLoading,
    handleClickRow,
    watchedRecords,
  } = props;

  return (
    <div className="orders__table">
      <Table
        locale={{
          emptyText: ordersLoading ? placeholder : 'Заказов нет...',
        }}
        columns={renderColumns()}
        dataSource={orders}
        rowKey="id"
        pagination={{ pageSize: pages }}
        onRow={handleClickRow}
        onChange={onChangeTable}
        // rowSelection={rowSelection}
        scroll={tableColumnsLen > 8 ? { x: '140%' } : { x: false }}
        rowClassName={record =>
          watchedRecords && !record.watched ? 'orders-row_unwatched' : ''
        }
      />
      {orders.length > 0 ? (
        <TablePageSize pages={pages} changePaginationSize={changePaginationSize} />
      ) : null}
    </div>
  );
};

export default OrdersTable;
